import {
  Step,
  StepLabel,
  Stepper as MuiStepper,
  useMediaQuery,
  useTheme,
} from "@mui/material";

type Orientation = "vertical" | "horizontal";

type CustomStepperProps = {
  steps: Array<{
    label: any;
  }>;
  currentStep: number;
  orientation?: Orientation;
};

export default function Stepper({
  steps,
  currentStep,
  orientation,
}: CustomStepperProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let orientationProp;

  if (orientation) {
    orientationProp = orientation;
  } else {
    orientationProp = (isMobile ? "vertical" : "horizontal") as Orientation;
  }

  return (
    <MuiStepper
      alternativeLabel={!isMobile}
      activeStep={currentStep}
      orientation={orientationProp}
    >
      {steps.map((step, i) => (
        <Step
          key={i}
          sx={{
            "& .MuiStepLabel-root .Mui-completed": {
              color: "green",
            },
            "& .MuiStepLabel-root .Mui-active": {
              color: "blue",
            },
          }}
        >
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
}
